// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/siyuan/font.css'
Vue.config.productionTip = false
import ElementUI from 'element-ui'
 
import 'element-ui/lib/theme-chalk/index.css'
import submit from './utils/submit'
Vue.prototype.$submit = submit;
import "swiper/css/swiper.min.css";
Vue.use(ElementUI)
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)
// main.js
import 'lib-flexible'

import 'lib-flexible/flexible.js'

import store from './store/index';
Vue.prototype.$store=store
Vue.prototype.$bus = new Vue()
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
import "@/assets/css/commot.css"

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js